import { render, staticRenderFns } from "./CardapioItem.vue?vue&type=template&id=128071e4&scoped=true"
import script from "./CardapioItem.vue?vue&type=script&lang=js"
export * from "./CardapioItem.vue?vue&type=script&lang=js"
import style0 from "./CardapioItem.vue?vue&type=style&index=0&id=128071e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128071e4",
  null
  
)

export default component.exports